import clsx from "clsx";
import {
	FacebookShareButton,
	LinkedinShareButton,
	TwitterShareButton,
} from "react-share";

const Share = ({ url, title }) => {
	const buttonClassName = clsx(
		"Share__button",
		"text-xs",
		"border rounded-sm",
		"text-xs px-2 py-1 "
	);

	const buttons = [
		<LinkedinShareButton
			key="linkedin"
			url={url}
			resetButtonStyle={false}
			className={buttonClassName}
			title={title}
		>
			LinkedIn
		</LinkedinShareButton>,
		<FacebookShareButton
			key="facebook"
			url={url}
			resetButtonStyle={false}
			className={buttonClassName}
			title={title}
		>
			Facebook
		</FacebookShareButton>,
		<TwitterShareButton
			key="twitter"
			url={url}
			resetButtonStyle={false}
			className={buttonClassName}
			title={title}
		>
			Twitter
		</TwitterShareButton>,
	];

	return (
		<div className={clsx("Share")}>
			<div className={clsx("Share__heading", "mb-2 font-medium text-xl")}>
				Share via:
			</div>
			<div className={clsx("Share__buttons", "flex", "group", "space-x-2")}>
				{buttons.map((button, index) => {
					return (
						<div
							key={index}
							className={clsx(
								"Share__buttonContainer",
								"transition-opacity",
								"group-hover:opacity-25 hover:!opacity-100"
							)}
						>
							{button}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Share;
